import script from "./chooseEquipment.vue?vue&type=script&lang=ts&setup=true"
export * from "./chooseEquipment.vue?vue&type=script&lang=ts&setup=true"

import "./chooseEquipment.vue?vue&type=style&index=0&id=ac451c34&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac451c34"]])

export default __exports__